// Generated by Melange

import Numeral from "numeral";

function format(value) {
  const result = Numeral(value.VAL);
  const result$1 = result.format("0,0.00");
  return result$1.replace(/,/g, "\u2009");
}

function formatInt(value) {
  const result = Numeral(value.VAL);
  const result$1 = result.format("0,0");
  return result$1.replace(/,/g, "\u2009");
}

function formatSalary(value) {
  const result = Numeral(value.VAL);
  const formatted = result.format("0");
  return formatted.replace(/\B(?=(\d{3})+(?!\d))/g, "\u2009");
}

export {
  format,
  formatInt,
  formatSalary,
}
/* numeral Not a pure module */
